// import { toastr } from 'react-redux-toastr';

export const HANDLE_UNCAUGHT_EXCEPTION = 'HANDLE_UNCAUGHT_EXCEPTION';

function requestHandleUncaughtException(exception) {
  return {
    type: HANDLE_UNCAUGHT_EXCEPTION,
    code: 0,
    message: exception.message
  };
}

export function handleUncaughtException(exception, callbackActionCreator, showAlert) {
  return (dispatch) => {
    if (showAlert) {
      // toastr.error(
      //   'Error',
      //   exception.message
      //     ? exception.message
      //     : 'Something went wrong, please try again or contact with administrators.'
      // );
    }
    if (callbackActionCreator && typeof callbackActionCreator === 'function') {
      return dispatch(callbackActionCreator(exception.data));
    }
    return dispatch(requestHandleUncaughtException(exception));
  };
}
